interface SectionHeaderProps {
  children: React.ReactNode;
}

export function SectionHeader({ children }: SectionHeaderProps) {
  return (
    <div className="mb-4 flex h-9 max-w-[700px] items-center rounded-lg bg-foreground px-3 text-white">
      <h4 className="text-sm font-semibold">{children}</h4>
    </div>
  );
}
